import React, { memo } from 'react';
import { HStack, Text } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';
// TODO: remember to delete when fully moved to parallax inputs
const InputErrorField = memo(({ testID, errorMessage }) => {
    if (!errorMessage) {
        return null;
    }
    return (React.createElement(HStack, { marginBottom: "$2" },
        React.createElement(IconValidationInvalid, { color: "$support.danger.surfaceOnColorAlt", testID: `${testID}-icon` }),
        React.createElement(Text, { display: "flex", testID: `${testID}-errorMessage`, nativeID: `${testID}-errorMessage`, color: "$support.danger.surfaceOnColorAlt", fontSize: "$bodySmall.default", marginLeft: "$2" }, errorMessage)));
});
InputErrorField.displayName = 'InputErrorField';
export { InputErrorField };
